import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import customCss from './App.module.css'
import Navbar from "./components/Navbar";
import Landing from "./components/Landing";
import LandingKpiDashboard from "./components/automateKpiDashboard/LandingKpiDashboard";
import LandingTestManagement from "./components/automateKpiDashboard/Landingtestmanagement";
import Login from "./components/users/login/index.jsx";
import Register from "./components/users/registration/index.jsx";
import AllUsers from "./components/users/js/AllUsers";
import Profile from "./components/users/js/Profile";
import ResetPassword from "./components/users/js/ResetPassword";
import SetPassword from "./components/users/js/SetPassword";
import ViewScenario from "./container/ViewScenario";
import Dashboard from "./container/dashboard";
import Dashboard_Level2 from "./container/dashboard_lvl2";
import ScenarioManager from "./container/ScenarioManager";
import UploadFile from "./components/test_table";
import ScenarioGroup from "./components/ScenarioGroup";
import AddScenario from "./components/AddScenarioGroup";
import TestRunStatus from "./container/TestRunStatus";
import AddTestPoint from "./components/AddTestPoint";
import BenchManager from "./components/BenchManager";
import ClosedLoopAndSceneExtract from "./components/ClosedLoopAndSceneExtract";
import OpenLoopLanding from "./components/openLoopLanding";
import Navigate from "./components/Navigate";
import NavigateNew from "./components/NavigateNew";
import Welcome from "./components/scenarioCatalogue/Welcome";
import ScenarioCatalogueDashboard from "./components/scenarioCatalogue/Dashboard";
import ScenarioCatalogueView from "./components/scenarioCatalogue/ViewScenarioCatalogue";
import AboutComponent from "./components/scenarioCatalogue/About";
//import KDataAnalyzer from './components/dataAnalyzer/Home'
//import Plotter from './components/dataAnalyzer/Plotter'
import Home from "./components/kpiManager/Landing";
import FunctionKPI from "./components/kpiManager/FunctionKPI";
import ComponentKPI from "./components/kpiManager/ComponentsKPI";
import KPIDashboardWelcome from "./components/kpi_dashboard_welcome";
import KPIDashboardWelcomeOpenLoop from "./components/automateKpiDashboard/KpiDashboardOpenloop";
import KPIDashboardWelcomeCloseLoop from "./components/automateKpiDashboard/KpiDashboardCloseloop";
import UploadScenarioClosedLoop from "./components/closedLoop/uploadScenarioClosedLoop";
import CloseLoopViewScenario from "./components/closedLoop/scenarioViewer";
import CloseLoopViewCustomMap from "./components/closedLoop/customMapViewer";
import CloseLoopViewAdClient from "./components/closedLoop/adClientViewer";
import CloseLoopScenarioGroup from "./components/closedLoop/closeLoopScenarioGroup";
import closeLoopBaseScenarioCollection from "./components/closedLoop/closeLoopBaseScenarioCollection";
// import CloseLoopScenarioGroupNew from "./components/closedLoop/CloseLoopScenarioGroupNew"
import UploadFileCloseLoop from "./components/closedLoop/testTableCloseLoop.js";
import TestRunStatusCloseLoop from "./components/closedLoop/TestRunStatusCloseLoop";
import TestRunStatusCloseLoopRevised from "./container/TestRunStatusCloseLoopRevised";
import ViewSceneGenData from "./components/sceneGen/ViewSceneGenData";
import ScenarioTjaV2 from "./components/automate_kpi_tja_v2/Scenario";
import SystemAndOtherStatisticsTjaV2 from "./components/automate_kpi_tja_v2/SystemAndOtherStatistics";
import KpiSummaryDashboardTjaV2 from "./components/automate_kpi_tja_v2/KpiSummaryDashboard";
// import KpiSummaryDashboardVersion2 from "./components/automate_kpi_tja_v2/KpiSummaryDashboardVersion2";
import KpiReport from "./components/automate_kpi_tja_v2/KpiReport";
import KpiSummaryLevelThree from "./components/automate_kpi_tja_v2/KpiSummaryDashboardEnhanced/KpiSummaryLevelThree";
import KpiSummaryScenarioFilterDashboard from "./components/automate_kpi_tja_v2/KpiSummaryDashboardEnhanced/KpiSummaryScenarioFilterDashboard";
import KpiDetailedDashboardTjaV2 from "./components/automate_kpi_tja_v2/KpiDetailedDashboard";
// import MainTjaV2 from "./components/automate_kpi_tja_v2/Main";
import scenarioEditor from "./components/sceneGen/scenarioEditor";
import ScenarioEditorView from "./components/sceneGen/ViewScenarioEditor";
import WelcomeAutomate from "./components/WelcomeAutomateKpi";
import AutomateKpiWelcome from "./components/automate_kpi/automate_kpi_welcome";
import camera from "./components/kpiManager/camera";
import lidar from "./components/kpiManager/lidar";
import radar from "./components/kpiManager/radar";
import AEB from "./components/kpiManager/AEB";
import LKA from "./components/kpiManager/LKA";
import ACC from "./components/kpiManager/ACC";
import TSR from "./components/kpiManager/TSR";
import LCA from "./components/kpiManager/LCA";
import AES from "./components/kpiManager/AES";
import ISA from "./components/kpiManager/ISA";
import BSD from "./components/kpiManager/BSD";
import LOC from "./components/kpiManager/LOC";
import LOF from "./components/kpiManager/LOF";
//import SceneExtract from './components/sceneExtract/sceneExtract'
import SceneProfiling from "./components/sceneExtract/SceneProfiling";
import DigitalTwin from "./components/sceneExtract/DigitalTwin";
import lkaScenarioExtractor from "./components/lkaScenarioExtractor/Home";
import CadTopology from "./components/cad_cloud_topology/CadTopology";
import apm_file_list from "./components/apm_file_list/apm_file_list_view";
import apm_dashboard from "./components/apm_file_list/apm_dashboard";
import PerformanceReport from "./components/closedLoop/performanceReport/landing";
import ArtifactDashboard from "./components/closedLoop/artifactDashboard/landing";
import TagNames from "./components/closedLoop/performanceReport/tagNamesCAD";
import CadRunStatus from "./components/cad_cloud_topology/cad_test_run_status";
import ScenarioFileUpload from "./components/closedLoop/scenarioFileUpload/scenarioFileUpload";
import MapAdUpload from "./components/closedLoop/mapAdUpload/mapAdUpload";
import BulkScenarioGroup from "./components/closedLoop/bulkScenarioGroup/bulkScenarioGroup";
import ScenarioVariationUpload from "./components/closedLoop/scenarioVariationUpload/scenarioFileUpload";
import ScenarioVariationUploadEnhanced from "./components/closedLoop/scenarioVariationUpload/scenarioFileUploadEnhanced";

import KPIDashboard from "./components/closedLoop/kpiDashboard/landing";
import APMDashboard from "./components/closedLoop/apmDashboard/index";
import InstancesStats from "./components/closedLoop/apmDashboard/revised/instances/InstanceStats";
import InstanceHealth from "./components/closedLoop/apmDashboard/container/index";

import Validation from "./components/closedLoop/validation/index";
import OpenLoopValidation from "./components/CM/cm_open_loop/validation";
import Navigator from "./components/Navigator";

import Topology from "./components/closedLoop/topology/index";

//import StoreMiddleWare from "./authComponents/globalAxios";
import { requireAuthentication } from "./authComponents/CheckAccess";
import "./authComponents/globalAxios";
import ScenarioCollection from "./components/closedLoop/scenarioCollection/main";
import scenarioFileUploadEnhanced from "./components/CM/cm_close_loop/scenarioCarMakerFileUpload/scenarioFileUploadEnhanced.js";
import CustomMapMain from "./components/closedLoop/mapAdUpload/customMapMainComponent";
import ScenarioListing from "./components/CM/cm_close_loop/ScenarioListing";
import WelcomCM from "./components/CM/cm_shared/CMWelcome/index.jsx";
import CarmakerScenarioFileUpload from "./components/CM/cm_close_loop/scenarioCarMakerFileUpload/scenarioFileUploadEnhanced.js";
import OpenLoopAndSceneExtract from "./components/CM/cm_open_loop/components/openLoopAndSceneExtract/index.js";
import main from "./components/CM/cm_open_loop/components/fusionDataListing/main.js";
import CMCriteriaMasters from "./components/CM/cm_shared/CMCriteriaMasters/index.jsx";
import TopologyListing from "./components/CM/cm_close_loop/TopologyListing";
import OpenLoopTopologyListing from "./components/CM/cm_open_loop/TopologyListing/index.jsx";
import DownloadArchiveList from "./components/CM/cm_shared/CMDownloadArchiveList/index.jsx"
import ScenarioGroupListing from "./components/CM/cm_close_loop/ScenarioGroupListing/index.jsx";
import ExecutionList from "./components/CM/cm_shared/Reporting/ExecutionList/index.jsx";
// import PR_Report from "./components/CM/cm_open_loop/components/PR_Report/index.jsx";
import OpenLoopListing from "./components/CM/cm_open_loop/OpenLoopListing/index.jsx";
import OpenLoopScenarioGroupListing from "./components/CM/cm_open_loop/ScenarioGroupListing/index.jsx";
import ExecutionListing from "./components/CM/cm_close_loop/ExecutionListing/index.jsx";
import ExecutionListingOfOpenLoop from './components/CM/cm_open_loop/ExecutionListing/index.jsx'
import PRDataSubtableResimulationHistory from "./components/CM/cm_open_loop/PRDataSubtableResimulationHistory/index.jsx";
import Sidebar from "./components/Sidebar/Sidebar";
// import ExecutionList from "./components/Reporting/ExecutionList";
// import ScenarioGroupListing from "./components/CM/cm_close_loop/scenarioCarMakerCollection/ScenarioGroupListing/index.jsx";
// import TopologyListing from "./components/CM/cm_close_loop/scenarioCarMakerCollection/TopologyListing/index.jsx";

import PrReport from "./components/CM/cm_open_loop/components/OpenLoopPRMain/index.jsx"
import PGScenarioListing from "./components/CM/cm_open_loop/PGScenarioListing/index.jsx";
// import ReportingModePGScenarioListing from "./components/CM/cm_open_loop/ReportingMode/index.jsx"
import PRScenarioListing from "./components/CM/cm_open_loop/PRScenarioListing/index.jsx";
// import ReportingModePGScenarioListing from "./components/CM/cm_open_loop/ReprotingMode/listings.jsx"
import OpenLooReportingMode from "./components/CM/cm_open_loop/ReprotingMode/index.jsx"
import { exact } from "prop-types";

const CompMap=new Map();
const componentFunction=(NavbarStatus,component,path)=>{
  if(CompMap.has(path))
    return CompMap.get(path);

  const CompReq=requireAuthentication(NavbarStatus,component,path);
  CompMap.set(path,CompReq);
  return CompReq;
}
const sideBarRoutes=[
  {
    path: "/welcome",
    exact: true,
    component: () => WelcomCM
  },
  {
    path: "/register",
    exact:true,
    component: () =>componentFunction("NavBarNotReq",Register,"/register")
  },
  {
    path: "/all_users",
    exact:true,
    component: () => componentFunction("NavBarNotReq",AllUsers,"/all_users")
  }
];
class App extends Component {

  constructor()
    {
    super()
    this.state ={sideBar:false}
    }
    SidebarHandler() {
    this.setState({
      sideBar:!this.state.sideBar
    })
  }
  render() {
    const Container = () => (
      <React.Fragment>
       
        {window.location.pathname === "/navigate" ||
          window.location.pathname === "/navigate_new" ||
          window.location.pathname === "/welcome_scenario_catalogue" ||
          window.location.pathname === "/dashboard_scenario_catalogue" ||
          window.location.pathname === "/" ||
          window.location.pathname === "/all_users" ||
          window.location.pathname === "/profile" ||
          window.location.pathname.includes("/reset-password") ||
          window.location.pathname.includes("/set-password") ||
          window.location.pathname.includes("/close_loop/topology") ||
          window.location.pathname.includes(
            "/close_loop/pre-validation/configuration"
          ) ||
          window.location.pathname.includes(
            "/close_loop/running/bench-instances/health/:region/:instanceId"
          ) ||
          window.location.pathname.includes(
            "/close_loop/running/bench-instances/:region"
          ) ||
          window.location.pathname.includes(
            "/close_loop/real_time/apm/dashboard"
          ) ||
          window.location.pathname.includes(
            "/close_loop_scenario_collection_enhanced"
          ) ||
          window.location.pathname.includes(
            "/close_loop_cm_scenario_collection_enhanced"
          ) ||
          window.location.pathname.includes(
            "/close_loop_scenario_collection_enhanced/cm_scenario_file/upload"
          ) ||
          window.location.pathname.includes(
            "/close_loop_scenario_collection_enhanced/scenario_file/upload"
          ) ||
          window.location.pathname.includes("/close_loop_scenario_group") ||
          window.location.pathname.includes("/scenario_variation/upload") ||
          window.location.pathname.includes(
            "/scenario_variation/upload_enhanced"
          ) ||
          window.location.pathname.includes("/custom_maps") ||
          window.location.pathname.includes("/view_scenario_catalogue") ||
          window.location.pathname.includes("/close_loop") === true ||
          window.location.pathname === "/about_scenario_catalogue" ||
          window.location.pathname === "/k-data_analyzer" ||
          window.location.pathname === "/plotter" ||
          window.location.pathname === "/event_analyzer_filtering" ||
          window.location.pathname === "/scene_profiling" ||
          window.location.pathname === "/digital_twin" ||
          // window.location.pathname.includes("/AutomateKPI") ||
          window.location.pathname.includes("/KpiReport") ||
          window.location.pathname.includes("/KpiSummaryLevelThree") ||
          window.location.pathname.includes(
            "/KpiSummaryScenarioFilterDashboard"
          ) ||
          window.location.pathname === "/welcome"||
          window.location.pathname === "/register" ||
          // window.location.pathname.includes('/GoodScenarioDashboard') ||
          // window.location.pathname.includes('/NoGoodScenarioDashboard') ||
          window.location.pathname.includes(
            "/close_loop/individual/kpi/dashboard"
          ) === true ? undefined : (
          <Navbar />
        )}
        <Route exact path="/welcome_old" component={Landing} />
        <Route
          exact
          path="/landingtestmanagement"
          component={LandingTestManagement}
        />
        <Route
          exact
          path="/welcomeautomatekpi/landingkpidashboard"
          component={LandingKpiDashboard}
        />
        {/* <Route exact path="/AutomateKPI" component={MainTjaV2} />
        <Route exact path="/AutomateKPI/:activeTab" component={MainTjaV2} />
        <Route
          exact
          path="/AutomateKPI/:activeTab/:sceneId"
          component={MainTjaV2}
        /> */}
        <Route exact path="/reporting" component={ExecutionList} />
        {/* <Route exact path="/open-loop" component={OpenLoopListing} /> */}
        <Route exact path="/open-loop-pg" component={PGScenarioListing} />
        <Route exact path="/reporting-mode" component={OpenLooReportingMode} />
        <Route exact path="/open-loop-pr" component={PRScenarioListing} />
        <Route exact path="/pr_data_subtable_resimulation_history/:id" component={PRDataSubtableResimulationHistory} />

        <Route
          exact
          path="/close_loop/execution_listing"
          // component={ExecutionListing}

          component={requireAuthentication(
            "NavBarReq",
            ExecutionListing,
            "/close_loop_cm_scenario_collection_enhanced"
          )}
        />
        <Route
          exact
          path="/open_loop/execution_listing"
          component={ExecutionListingOfOpenLoop}
        />
        <Route
          exact
          path="/open_loop_scenario_group"
          component={OpenLoopScenarioGroupListing}
        />
        <Route
          exact
          path="/cm_open_loop_topology"
          component={OpenLoopTopologyListing}
        />

        <Route
          exact
          path="/close_loop/individual/kpi/dashboard"
          component={requireAuthentication(
            "NavBarNotReq",
            KPIDashboard,
            "/close_loop/individual/kpi/dashboard"
          )}
        />
        <Route exact path="/welcomeautomatekpi" component={WelcomeAutomate} />
        <Route
          exact
          path="/kpidashboardopenloop"
          component={KPIDashboardWelcomeOpenLoop}
        />
        <Route
          exact
          path="/kpidashboardcloseloop"
          component={KPIDashboardWelcomeCloseLoop}
        />
        <React.Fragment>
          {/* <Route
            exact
            path="/register"
            component={requireAuthentication(
              "NavBarNotReq",
              Register,
              "/register"
            )}
          /> */}
          {/* <Route
            exact
            path="/all_users"
            component={requireAuthentication(
              "NavBarNotReq",
              AllUsers,
              "/all_users"
            )}
          /> */}
          <Route
            exact
            path="/"
            component={requireAuthentication("NavBarNotReq", Login, "/")}
          />
          <Route
            exact
            path="/profile"
            component={requireAuthentication(
              "NavBarNotReq",
              Profile,
              "/profile"
            )}
          />
          <Route exact path="/reset-password" component={ResetPassword} />
          <Route exact path="/set-password" component={SetPassword} />
          <Route exact path="/view_scenario" component={ViewScenario} />
          <Route exact path="/upload_file" component={UploadFile} />
          <Route exact path="/camera_dashboard_level3" component={Dashboard} />
          <Route
            exact
            path="/camera_dashboard_level2"
            component={Dashboard_Level2}
          />
          <Route exact path="/scenario_group" component={ScenarioGroup} />
          <Route exact path="/scenario_manager" component={ScenarioManager} />
          <Route exact path="/addScenario" component={AddScenario} />
          <Route exact path="/testRunStatus" component={TestRunStatus} />
          <Route exact path="/addTestPoint" component={AddTestPoint} />
          <Route exact path="/bench_manager" component={BenchManager} />
          <Route
            exact
            path="/close_loop"
            component={requireAuthentication(
              "NavBarReq",
              ClosedLoopAndSceneExtract,
              "/close_loop"
            )}
          />
          <Route
            exact
            path="/scene_extract"
            component={ClosedLoopAndSceneExtract}
          />
          <Route
            exact
            path="/open_loop/fusion_data_listing"
            component={OpenLoopAndSceneExtract}
          />
          <Route
            exact
            path="/open_loop_cm_fusion_data_collection_enhanced"
            component={main}
          />
          <Route exact path="/open_loop" component={OpenLoopLanding} />
          {/* <Route exact path="/k-data_analyzer" component={KDataAnalyzer}/>
          <Route exact path="/plotter" component={Plotter}/>*/}
          <Route exact path="/kpi_manager" component={Home} />
          <Route exact path="/function_kpi" component={FunctionKPI} />
          <Route exact path="/components_kpi" component={ComponentKPI} />
          <Route
            exact
            path="/welcome_kpi_dashboard"
            component={KPIDashboardWelcome}
          />
          <Route
            exact
            path="/view_valid_scene_data"
            component={ViewSceneGenData}
          />
          <Route
            exact
            path="/close_loop_upload_scenario"
            component={UploadScenarioClosedLoop}
          />
          <Route
            exact
            path="/close_loop_view_scenario"
            component={CloseLoopViewScenario}
          />
          <Route
            exact
            path="/close_loop_custom_map_listings"
            component={CloseLoopViewCustomMap}
          />
          <Route
            exact
            path="/close_loop_ad_client_listings"
            component={CloseLoopViewAdClient}
          />
          <Route
            exact
            path="/close_loop_scenario_group"
            component={requireAuthentication(
              "NavBarReq",
              CloseLoopScenarioGroup,
              "/close_loop_scenario_group"
            )}
          />
          <Route
            exact
            path="/close_loop_scenario_collection"
            component={closeLoopBaseScenarioCollection}
          />
          {/* <Route exact path="/close_loop_scenario_group" component={CloseLoopScenarioGroupNew}/> */}
          <Route
            exact
            path="/close_loop_scheduler"
            component={UploadFileCloseLoop}
          />
          <Route
            exact
            path="/close_loop_test_run_status"
            component={TestRunStatusCloseLoop}
          />
          <Route
            exact
            path="/close_loop_test_run_status_Revised"
            component={TestRunStatusCloseLoopRevised}
          />
          <Route exact path="/ScenarioTjaV2" component={ScenarioTjaV2} />
          <Route
            exact
            path="/SystemAndOtherStatisticsTjaV2"
            component={SystemAndOtherStatisticsTjaV2}
          />
          <Route
            exact
            path="/KpiSummaryDashboardTjaV2"
            component={KpiSummaryDashboardTjaV2}
          />
          {/* <Route
            exact
            path="/KpiSummaryDashboardVersion2"
            component={KpiSummaryDashboardVersion2}
          /> */}
          <Route exact path="/KpiReport" component={KpiReport} />
          <Route
            exact
            path="/KpiSummaryLevelThree"
            component={requireAuthentication(
              "NavBarNotReq",
              KpiSummaryLevelThree,
              "/KpiSummaryLevelThree"
            )}
          />
          <Route
            exact
            path="/KpiSummaryScenarioFilterDashboard"
            component={requireAuthentication(
              "NavBarNotReq",
              KpiSummaryScenarioFilterDashboard,
              "/KpiSummaryScenarioFilterDashboard"
            )}
          />
          <Route
            exact
            path="/KpiDetailedDashboardTjaV2"
            component={KpiDetailedDashboardTjaV2}
          />
          {/* <Route
            exact
            path="/ScenarioDetailsDashboard"
            component={ScenarioDetailsDashboard}
          /> */}
          {/* <Route
            exact
            path="/GoodScenarioDashboard"
            component={GoodScenarioDashboard}
          /> */}
          {/* <Route
            exact
            path="/NoGoodScenarioDashboard"
            component={NoGoodScenarioDashboard}
          /> */}

          <Route exact path="/scenario_editor" component={scenarioEditor} />
          <Route
            exact
            path="/view_scenario_editor"
            component={ScenarioEditorView}
          />

          <Route
            exact
            path="/automate_kpi_welcome"
            component={AutomateKpiWelcome}
          />
          <Route exact path="/camera" component={camera} />
          <Route exact path="/lidar" component={lidar} />
          <Route exact path="/radar" component={radar} />
          <Route exact path="/Automatic_Emergency_Braking" component={AEB} />
          <Route exact path="/Lane_Keeping_Assist" component={LKA} />
          <Route exact path="/Adaptive_Cruise_Control" component={ACC} />
          <Route exact path="/Traffic_Sign_Recognition" component={TSR} />
          <Route exact path="/Lane_Change_Assist" component={LCA} />
          <Route exact path="/Automatic_Emergency_Steering" component={AES} />
          <Route exact path="/Intelligent_Speed_Adaptation" component={ISA} />
          <Route exact path="/Blind_Spot_Detection" component={BSD} />
          <Route exact path="/List_of_components" component={LOC} />
          <Route exact path="/List_of_features" component={LOF} />

          {/*<Route exact path="/event_analyzer_filtering" component={SceneExtract}/>*/}
          <Route exact path="/scene_profiling" component={SceneProfiling} />
          <Route exact path="/digital_twin" component={DigitalTwin} />
          <Route
            exact
            path="/lka_scenario_extractor"
            component={lkaScenarioExtractor}
          />
          <Route exact path="/CadTopology" component={CadTopology} />
          <Route exact path="/apm_file_list" component={apm_file_list} />
          <Route exact path="/apm_dashboard" component={apm_dashboard} />
          <Route
            exact
            path="/close_loop/performance_report"
            component={PerformanceReport}
          />
          <Route
            exact
            path="/close_loop/performance_report/:testRun"
            component={PerformanceReport}
          />
          <Route
            exact
            path="/close_loop/artifact_dashboard"
            component={ArtifactDashboard}
          />
          <Route exact path="/close_loop/cad/tag_names" component={TagNames} />
          <Route exact path="/cad_test_run_status" component={CadRunStatus} />
          <Route
            exact
            path="/scenario_file/upload"
            component={ScenarioFileUpload}
          />
          <Route
            exact
            path="/scenario_variation/upload"
            component={requireAuthentication(
              "NavBarReq",
              ScenarioVariationUpload,
              "/scenario_variation/upload"
            )}
          />
          <Route
            exact
            path="/scenario_variation/upload_enhanced"
            component={requireAuthentication(
              "NavBarReq",
              ScenarioVariationUploadEnhanced,
              "/scenario_variation/upload_enhanced"
            )}
          />
          <Route
            exact
            path="/custom_maps"
            component={requireAuthentication(
              "NavBarReq",
              CustomMapMain,
              "/custom_maps"
            )}
          />
          <Route
            exact
            path="/scenario_group/bulk_creation"
            component={BulkScenarioGroup}
          />
          <Route exact path="/navigatev1" component={Navigator} />
          <Route exact path="/map_ad/upload" component={MapAdUpload} />

          <Route
            exact
            path="/close_loop/real_time/apm/dashboard"
            component={requireAuthentication(
              "NavBarReq",
              APMDashboard,
              "/close_loop/real_time/apm/dashboard"
            )}
          />
          <Route
            exact
            path="/close_loop/pre-validation/configuration"
            component={requireAuthentication(
              "NavBarReq",
              Validation,
              "/close_loop/pre-validation/configuration"
            )}
          />
          <Route
            exact
            path="/open_loop/pre-validation/configuration"
            // component={requireAuthentication(
            //   "NavBarReq",
            //   OpenLoopValidation,
            //   "/open_loop/pre-validation/configuration"
            // )}
            component={OpenLoopValidation}
          />
          <Route
            exact
            path="/close_loop/topology"
            component={requireAuthentication(
              "NavBarReq",
              Topology,
              "/close_loop/topology"
            )}
          />
          <Route
            exact
            path="/close_loop/close_cm_loop_topology"
            component={requireAuthentication(
              "NavBarReq",
              // CmTopology,
              TopologyListing,
              "/close_loop/close_cm_loop_topology"
            )}
          // component={TopologyListing}
          />
          <Route
            exact
            path="/download_archive_list"
            component={requireAuthentication(
              "NavBarNotReq",
              // CmTopology,
              DownloadArchiveList,
              "/close_loop_cm_scenario_collection_enhanced"
            )}
          />
          <Route
            exact
            path="/close_loop/running/bench-instances/:region"
            component={requireAuthentication(
              "NavBarReq",
              InstancesStats,
              "/close_loop/running/bench-instances/:region"
            )}
          />
          <Route
            exact
            path="/close_loop/running/bench-instances/health/:region/:instanceId"
            component={requireAuthentication(
              "NavBarReq",
              InstanceHealth,
              "/close_loop/running/bench-instances/health/:region/:instanceId"
            )}
          />
          <Route
            exact
            path="/close_loop_scenario_collection_enhanced"
            component={requireAuthentication(
              "NavBarReq",
              ScenarioCollection,
              "/close_loop_scenario_collection_enhanced"
            )}
          />
          <Route
            exact
            path="/close_loop_scenario_collection_enhanced/scenario_file/upload"
            component={requireAuthentication(
              "NavBarReq",
              scenarioFileUploadEnhanced,
              "/close_loop_scenario_collection_enhanced/scenario_file/upload"
            )}
          />
          <Route
            exact
            path="/close_loop_cm_scenario_collection_enhanced"
            component={requireAuthentication(
              "NavBarReq",
              ScenarioListing,
              "/close_loop_cm_scenario_collection_enhanced"
            )}
          />

          <Route
            exact
            path="/close_loop_criteria_masters"
            component={requireAuthentication(
              "NavBarReq",
              CMCriteriaMasters,
              "/close_loop_cm_scenario_collection_enhanced"
            )}
          />
          {/* <Route
            exact
            path="/PR_Report_Screen2"
            component={PR_Report_Screen2}
          //component={requireAuthentication(
          // "NavBarReq",
          // PR_Report,
          //"/PR_Report"
          // )}
          /> */}

          <Route
            exact
            path="/PR_Report_Screen/:pageType"
            component={PrReport}
          //component={requireAuthentication(
          // "NavBarReq",
          // PR_Report,
          //"/PR_Report"
          // )}
          />
           {/* <Route
            exact
            path="/PR_Report_Screen3"
            component={PR_Report_Screen3}/> */}
          <Route
            exact
            path="/close_loop_scenario_collection_enhanced/cm_scenario_file/upload"
            component={CarmakerScenarioFileUpload}
          />
          <Route
            exact
            path="/close_cm_loop_scenario_group"
            // component={CmCloseLoopScenarioGroup}
            component={ScenarioGroupListing}
          />
        </React.Fragment>
      </React.Fragment>
    );
    return (
      <Router>
        <Switch>
          <div className="App">
            <Route exact path="/navigate" component={Navigate} />
            <Route exact path="/navigate_new" component={NavigateNew} />
            <Route
              exact
              path="/welcome_scenario_catalogue"
              component={Welcome}
            />
            <Route
              exact
              path="/dashboard_scenario_catalogue"
              component={ScenarioCatalogueDashboard}
            />
            <Route
              exact
              path="/view_scenario_catalogue"
              component={ScenarioCatalogueView}
            />
            <Route
              exact
              path="/view_scenario_catalogue/:queryValue"
              component={ScenarioCatalogueView}
            />
            <Route
              exact
              path="/about_scenario_catalogue"
              component={AboutComponent}
            />

            <Route component={Container} />

            <Route
                exact
                path={["/welcome", "/register", "/all_users"]}
                render={() => (
                  <>
                    <Sidebar
                      sideBar={this.state.sideBar}
                      handleSideBar={this.SidebarHandler.bind(this)}
                    />
                    <div
                      className={
                        !this.state.sideBar
                          ? customCss.nochange
                          : customCss.shiftBody
                      }
                    >
                      {sideBarRoutes.map((pages) => (
                        <>
                          <Route
                            exact={pages.exact}
                            path={pages.path}
                            component={pages.component()}
                          />
                        </>
                      ))}
                    </div>
                  </>
                )}
            />
          </div>
        </Switch>
      </Router>
    );
  }
}

export default App;
